import MusicaRockMetal from "./MusicaRockMetal";
import MusicaSoundtrack from "./MusicaSoundtrack";

const SeccionMusica = (): JSX.Element => {
  return (
    <div className='inner-section' style={{ backgroundColor: "lightcoral" }}>
      <h5 className='mt-4 text-center title-inner-section'>Musica:</h5>
      <MusicaRockMetal />
      <MusicaSoundtrack />
    </div>
  );
};

export default SeccionMusica;
